function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  className: "red-ui-workspace-chart-background",
  width: 5000,
  height: 5000
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 0,
  y2: 0
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 20,
  y2: 20
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 40,
  y2: 40
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 60,
  y2: 60
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 80,
  y2: 80
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 100,
  y2: 100
});

var _ref9 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 120,
  y2: 120
});

var _ref10 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 140,
  y2: 140
});

var _ref11 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 160,
  y2: 160
});

var _ref12 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 180,
  y2: 180
});

var _ref13 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 200,
  y2: 200
});

var _ref14 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 220,
  y2: 220
});

var _ref15 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 240,
  y2: 240
});

var _ref16 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 260,
  y2: 260
});

var _ref17 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 280,
  y2: 280
});

var _ref18 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 300,
  y2: 300
});

var _ref19 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 320,
  y2: 320
});

var _ref20 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 340,
  y2: 340
});

var _ref21 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 360,
  y2: 360
});

var _ref22 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 380,
  y2: 380
});

var _ref23 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 400,
  y2: 400
});

var _ref24 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 420,
  y2: 420
});

var _ref25 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 440,
  y2: 440
});

var _ref26 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 460,
  y2: 460
});

var _ref27 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 480,
  y2: 480
});

var _ref28 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 500,
  y2: 500
});

var _ref29 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 520,
  y2: 520
});

var _ref30 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 540,
  y2: 540
});

var _ref31 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 560,
  y2: 560
});

var _ref32 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 580,
  y2: 580
});

var _ref33 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 600,
  y2: 600
});

var _ref34 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 620,
  y2: 620
});

var _ref35 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 640,
  y2: 640
});

var _ref36 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 660,
  y2: 660
});

var _ref37 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 680,
  y2: 680
});

var _ref38 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 700,
  y2: 700
});

var _ref39 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 720,
  y2: 720
});

var _ref40 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 740,
  y2: 740
});

var _ref41 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 760,
  y2: 760
});

var _ref42 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 780,
  y2: 780
});

var _ref43 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 800,
  y2: 800
});

var _ref44 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 820,
  y2: 820
});

var _ref45 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 840,
  y2: 840
});

var _ref46 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 860,
  y2: 860
});

var _ref47 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 880,
  y2: 880
});

var _ref48 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 900,
  y2: 900
});

var _ref49 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 920,
  y2: 920
});

var _ref50 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 940,
  y2: 940
});

var _ref51 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 960,
  y2: 960
});

var _ref52 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 980,
  y2: 980
});

var _ref53 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1000,
  y2: 1000
});

var _ref54 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1020,
  y2: 1020
});

var _ref55 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1040,
  y2: 1040
});

var _ref56 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1060,
  y2: 1060
});

var _ref57 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1080,
  y2: 1080
});

var _ref58 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1100,
  y2: 1100
});

var _ref59 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1120,
  y2: 1120
});

var _ref60 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1140,
  y2: 1140
});

var _ref61 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1160,
  y2: 1160
});

var _ref62 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1180,
  y2: 1180
});

var _ref63 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1200,
  y2: 1200
});

var _ref64 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1220,
  y2: 1220
});

var _ref65 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1240,
  y2: 1240
});

var _ref66 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1260,
  y2: 1260
});

var _ref67 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1280,
  y2: 1280
});

var _ref68 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1300,
  y2: 1300
});

var _ref69 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1320,
  y2: 1320
});

var _ref70 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1340,
  y2: 1340
});

var _ref71 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1360,
  y2: 1360
});

var _ref72 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1380,
  y2: 1380
});

var _ref73 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1400,
  y2: 1400
});

var _ref74 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1420,
  y2: 1420
});

var _ref75 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1440,
  y2: 1440
});

var _ref76 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1460,
  y2: 1460
});

var _ref77 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1480,
  y2: 1480
});

var _ref78 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1500,
  y2: 1500
});

var _ref79 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1520,
  y2: 1520
});

var _ref80 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1540,
  y2: 1540
});

var _ref81 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1560,
  y2: 1560
});

var _ref82 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1580,
  y2: 1580
});

var _ref83 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1600,
  y2: 1600
});

var _ref84 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1620,
  y2: 1620
});

var _ref85 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1640,
  y2: 1640
});

var _ref86 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1660,
  y2: 1660
});

var _ref87 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1680,
  y2: 1680
});

var _ref88 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1700,
  y2: 1700
});

var _ref89 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1720,
  y2: 1720
});

var _ref90 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1740,
  y2: 1740
});

var _ref91 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1760,
  y2: 1760
});

var _ref92 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1780,
  y2: 1780
});

var _ref93 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1800,
  y2: 1800
});

var _ref94 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1820,
  y2: 1820
});

var _ref95 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1840,
  y2: 1840
});

var _ref96 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1860,
  y2: 1860
});

var _ref97 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1880,
  y2: 1880
});

var _ref98 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1900,
  y2: 1900
});

var _ref99 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1920,
  y2: 1920
});

var _ref100 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1940,
  y2: 1940
});

var _ref101 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1960,
  y2: 1960
});

var _ref102 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 1980,
  y2: 1980
});

var _ref103 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2000,
  y2: 2000
});

var _ref104 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2020,
  y2: 2020
});

var _ref105 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2040,
  y2: 2040
});

var _ref106 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2060,
  y2: 2060
});

var _ref107 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2080,
  y2: 2080
});

var _ref108 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2100,
  y2: 2100
});

var _ref109 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2120,
  y2: 2120
});

var _ref110 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2140,
  y2: 2140
});

var _ref111 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2160,
  y2: 2160
});

var _ref112 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2180,
  y2: 2180
});

var _ref113 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2200,
  y2: 2200
});

var _ref114 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2220,
  y2: 2220
});

var _ref115 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2240,
  y2: 2240
});

var _ref116 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2260,
  y2: 2260
});

var _ref117 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2280,
  y2: 2280
});

var _ref118 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2300,
  y2: 2300
});

var _ref119 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2320,
  y2: 2320
});

var _ref120 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2340,
  y2: 2340
});

var _ref121 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2360,
  y2: 2360
});

var _ref122 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2380,
  y2: 2380
});

var _ref123 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2400,
  y2: 2400
});

var _ref124 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2420,
  y2: 2420
});

var _ref125 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2440,
  y2: 2440
});

var _ref126 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2460,
  y2: 2460
});

var _ref127 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2480,
  y2: 2480
});

var _ref128 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2500,
  y2: 2500
});

var _ref129 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2520,
  y2: 2520
});

var _ref130 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2540,
  y2: 2540
});

var _ref131 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2560,
  y2: 2560
});

var _ref132 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2580,
  y2: 2580
});

var _ref133 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2600,
  y2: 2600
});

var _ref134 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2620,
  y2: 2620
});

var _ref135 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2640,
  y2: 2640
});

var _ref136 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2660,
  y2: 2660
});

var _ref137 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2680,
  y2: 2680
});

var _ref138 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2700,
  y2: 2700
});

var _ref139 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2720,
  y2: 2720
});

var _ref140 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2740,
  y2: 2740
});

var _ref141 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2760,
  y2: 2760
});

var _ref142 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2780,
  y2: 2780
});

var _ref143 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2800,
  y2: 2800
});

var _ref144 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2820,
  y2: 2820
});

var _ref145 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2840,
  y2: 2840
});

var _ref146 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2860,
  y2: 2860
});

var _ref147 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2880,
  y2: 2880
});

var _ref148 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2900,
  y2: 2900
});

var _ref149 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2920,
  y2: 2920
});

var _ref150 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2940,
  y2: 2940
});

var _ref151 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2960,
  y2: 2960
});

var _ref152 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 2980,
  y2: 2980
});

var _ref153 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3000,
  y2: 3000
});

var _ref154 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3020,
  y2: 3020
});

var _ref155 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3040,
  y2: 3040
});

var _ref156 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3060,
  y2: 3060
});

var _ref157 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3080,
  y2: 3080
});

var _ref158 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3100,
  y2: 3100
});

var _ref159 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3120,
  y2: 3120
});

var _ref160 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3140,
  y2: 3140
});

var _ref161 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3160,
  y2: 3160
});

var _ref162 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3180,
  y2: 3180
});

var _ref163 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3200,
  y2: 3200
});

var _ref164 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3220,
  y2: 3220
});

var _ref165 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3240,
  y2: 3240
});

var _ref166 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3260,
  y2: 3260
});

var _ref167 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3280,
  y2: 3280
});

var _ref168 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3300,
  y2: 3300
});

var _ref169 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3320,
  y2: 3320
});

var _ref170 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3340,
  y2: 3340
});

var _ref171 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3360,
  y2: 3360
});

var _ref172 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3380,
  y2: 3380
});

var _ref173 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3400,
  y2: 3400
});

var _ref174 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3420,
  y2: 3420
});

var _ref175 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3440,
  y2: 3440
});

var _ref176 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3460,
  y2: 3460
});

var _ref177 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3480,
  y2: 3480
});

var _ref178 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3500,
  y2: 3500
});

var _ref179 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3520,
  y2: 3520
});

var _ref180 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3540,
  y2: 3540
});

var _ref181 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3560,
  y2: 3560
});

var _ref182 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3580,
  y2: 3580
});

var _ref183 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3600,
  y2: 3600
});

var _ref184 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3620,
  y2: 3620
});

var _ref185 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3640,
  y2: 3640
});

var _ref186 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3660,
  y2: 3660
});

var _ref187 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3680,
  y2: 3680
});

var _ref188 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3700,
  y2: 3700
});

var _ref189 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3720,
  y2: 3720
});

var _ref190 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3740,
  y2: 3740
});

var _ref191 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3760,
  y2: 3760
});

var _ref192 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3780,
  y2: 3780
});

var _ref193 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3800,
  y2: 3800
});

var _ref194 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3820,
  y2: 3820
});

var _ref195 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3840,
  y2: 3840
});

var _ref196 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3860,
  y2: 3860
});

var _ref197 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3880,
  y2: 3880
});

var _ref198 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3900,
  y2: 3900
});

var _ref199 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3920,
  y2: 3920
});

var _ref200 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3940,
  y2: 3940
});

var _ref201 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3960,
  y2: 3960
});

var _ref202 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 3980,
  y2: 3980
});

var _ref203 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4000,
  y2: 4000
});

var _ref204 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4020,
  y2: 4020
});

var _ref205 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4040,
  y2: 4040
});

var _ref206 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4060,
  y2: 4060
});

var _ref207 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4080,
  y2: 4080
});

var _ref208 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4100,
  y2: 4100
});

var _ref209 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4120,
  y2: 4120
});

var _ref210 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4140,
  y2: 4140
});

var _ref211 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4160,
  y2: 4160
});

var _ref212 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4180,
  y2: 4180
});

var _ref213 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4200,
  y2: 4200
});

var _ref214 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4220,
  y2: 4220
});

var _ref215 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4240,
  y2: 4240
});

var _ref216 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4260,
  y2: 4260
});

var _ref217 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4280,
  y2: 4280
});

var _ref218 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4300,
  y2: 4300
});

var _ref219 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4320,
  y2: 4320
});

var _ref220 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4340,
  y2: 4340
});

var _ref221 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4360,
  y2: 4360
});

var _ref222 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4380,
  y2: 4380
});

var _ref223 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4400,
  y2: 4400
});

var _ref224 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4420,
  y2: 4420
});

var _ref225 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4440,
  y2: 4440
});

var _ref226 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4460,
  y2: 4460
});

var _ref227 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4480,
  y2: 4480
});

var _ref228 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4500,
  y2: 4500
});

var _ref229 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4520,
  y2: 4520
});

var _ref230 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4540,
  y2: 4540
});

var _ref231 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4560,
  y2: 4560
});

var _ref232 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4580,
  y2: 4580
});

var _ref233 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4600,
  y2: 4600
});

var _ref234 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4620,
  y2: 4620
});

var _ref235 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4640,
  y2: 4640
});

var _ref236 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4660,
  y2: 4660
});

var _ref237 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4680,
  y2: 4680
});

var _ref238 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4700,
  y2: 4700
});

var _ref239 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4720,
  y2: 4720
});

var _ref240 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4740,
  y2: 4740
});

var _ref241 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4760,
  y2: 4760
});

var _ref242 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4780,
  y2: 4780
});

var _ref243 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4800,
  y2: 4800
});

var _ref244 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4820,
  y2: 4820
});

var _ref245 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4840,
  y2: 4840
});

var _ref246 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4860,
  y2: 4860
});

var _ref247 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4880,
  y2: 4880
});

var _ref248 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4900,
  y2: 4900
});

var _ref249 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4920,
  y2: 4920
});

var _ref250 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4940,
  y2: 4940
});

var _ref251 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4960,
  y2: 4960
});

var _ref252 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-h",
  x1: 0,
  x2: 5000,
  y1: 4980,
  y2: 4980
});

var _ref253 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 0,
  x2: 0
});

var _ref254 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 20,
  x2: 20
});

var _ref255 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 40,
  x2: 40
});

var _ref256 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 60,
  x2: 60
});

var _ref257 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 80,
  x2: 80
});

var _ref258 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 100,
  x2: 100
});

var _ref259 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 120,
  x2: 120
});

var _ref260 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 140,
  x2: 140
});

var _ref261 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 160,
  x2: 160
});

var _ref262 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 180,
  x2: 180
});

var _ref263 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 200,
  x2: 200
});

var _ref264 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 220,
  x2: 220
});

var _ref265 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 240,
  x2: 240
});

var _ref266 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 260,
  x2: 260
});

var _ref267 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 280,
  x2: 280
});

var _ref268 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 300,
  x2: 300
});

var _ref269 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 320,
  x2: 320
});

var _ref270 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 340,
  x2: 340
});

var _ref271 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 360,
  x2: 360
});

var _ref272 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 380,
  x2: 380
});

var _ref273 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 400,
  x2: 400
});

var _ref274 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 420,
  x2: 420
});

var _ref275 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 440,
  x2: 440
});

var _ref276 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 460,
  x2: 460
});

var _ref277 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 480,
  x2: 480
});

var _ref278 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 500,
  x2: 500
});

var _ref279 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 520,
  x2: 520
});

var _ref280 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 540,
  x2: 540
});

var _ref281 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 560,
  x2: 560
});

var _ref282 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 580,
  x2: 580
});

var _ref283 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 600,
  x2: 600
});

var _ref284 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 620,
  x2: 620
});

var _ref285 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 640,
  x2: 640
});

var _ref286 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 660,
  x2: 660
});

var _ref287 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 680,
  x2: 680
});

var _ref288 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 700,
  x2: 700
});

var _ref289 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 720,
  x2: 720
});

var _ref290 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 740,
  x2: 740
});

var _ref291 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 760,
  x2: 760
});

var _ref292 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 780,
  x2: 780
});

var _ref293 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 800,
  x2: 800
});

var _ref294 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 820,
  x2: 820
});

var _ref295 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 840,
  x2: 840
});

var _ref296 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 860,
  x2: 860
});

var _ref297 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 880,
  x2: 880
});

var _ref298 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 900,
  x2: 900
});

var _ref299 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 920,
  x2: 920
});

var _ref300 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 940,
  x2: 940
});

var _ref301 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 960,
  x2: 960
});

var _ref302 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 980,
  x2: 980
});

var _ref303 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1000,
  x2: 1000
});

var _ref304 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1020,
  x2: 1020
});

var _ref305 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1040,
  x2: 1040
});

var _ref306 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1060,
  x2: 1060
});

var _ref307 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1080,
  x2: 1080
});

var _ref308 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1100,
  x2: 1100
});

var _ref309 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1120,
  x2: 1120
});

var _ref310 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1140,
  x2: 1140
});

var _ref311 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1160,
  x2: 1160
});

var _ref312 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1180,
  x2: 1180
});

var _ref313 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1200,
  x2: 1200
});

var _ref314 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1220,
  x2: 1220
});

var _ref315 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1240,
  x2: 1240
});

var _ref316 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1260,
  x2: 1260
});

var _ref317 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1280,
  x2: 1280
});

var _ref318 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1300,
  x2: 1300
});

var _ref319 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1320,
  x2: 1320
});

var _ref320 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1340,
  x2: 1340
});

var _ref321 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1360,
  x2: 1360
});

var _ref322 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1380,
  x2: 1380
});

var _ref323 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1400,
  x2: 1400
});

var _ref324 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1420,
  x2: 1420
});

var _ref325 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1440,
  x2: 1440
});

var _ref326 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1460,
  x2: 1460
});

var _ref327 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1480,
  x2: 1480
});

var _ref328 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1500,
  x2: 1500
});

var _ref329 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1520,
  x2: 1520
});

var _ref330 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1540,
  x2: 1540
});

var _ref331 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1560,
  x2: 1560
});

var _ref332 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1580,
  x2: 1580
});

var _ref333 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1600,
  x2: 1600
});

var _ref334 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1620,
  x2: 1620
});

var _ref335 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1640,
  x2: 1640
});

var _ref336 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1660,
  x2: 1660
});

var _ref337 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1680,
  x2: 1680
});

var _ref338 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1700,
  x2: 1700
});

var _ref339 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1720,
  x2: 1720
});

var _ref340 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1740,
  x2: 1740
});

var _ref341 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1760,
  x2: 1760
});

var _ref342 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1780,
  x2: 1780
});

var _ref343 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1800,
  x2: 1800
});

var _ref344 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1820,
  x2: 1820
});

var _ref345 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1840,
  x2: 1840
});

var _ref346 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1860,
  x2: 1860
});

var _ref347 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1880,
  x2: 1880
});

var _ref348 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1900,
  x2: 1900
});

var _ref349 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1920,
  x2: 1920
});

var _ref350 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1940,
  x2: 1940
});

var _ref351 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1960,
  x2: 1960
});

var _ref352 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 1980,
  x2: 1980
});

var _ref353 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2000,
  x2: 2000
});

var _ref354 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2020,
  x2: 2020
});

var _ref355 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2040,
  x2: 2040
});

var _ref356 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2060,
  x2: 2060
});

var _ref357 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2080,
  x2: 2080
});

var _ref358 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2100,
  x2: 2100
});

var _ref359 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2120,
  x2: 2120
});

var _ref360 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2140,
  x2: 2140
});

var _ref361 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2160,
  x2: 2160
});

var _ref362 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2180,
  x2: 2180
});

var _ref363 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2200,
  x2: 2200
});

var _ref364 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2220,
  x2: 2220
});

var _ref365 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2240,
  x2: 2240
});

var _ref366 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2260,
  x2: 2260
});

var _ref367 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2280,
  x2: 2280
});

var _ref368 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2300,
  x2: 2300
});

var _ref369 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2320,
  x2: 2320
});

var _ref370 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2340,
  x2: 2340
});

var _ref371 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2360,
  x2: 2360
});

var _ref372 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2380,
  x2: 2380
});

var _ref373 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2400,
  x2: 2400
});

var _ref374 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2420,
  x2: 2420
});

var _ref375 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2440,
  x2: 2440
});

var _ref376 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2460,
  x2: 2460
});

var _ref377 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2480,
  x2: 2480
});

var _ref378 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2500,
  x2: 2500
});

var _ref379 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2520,
  x2: 2520
});

var _ref380 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2540,
  x2: 2540
});

var _ref381 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2560,
  x2: 2560
});

var _ref382 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2580,
  x2: 2580
});

var _ref383 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2600,
  x2: 2600
});

var _ref384 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2620,
  x2: 2620
});

var _ref385 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2640,
  x2: 2640
});

var _ref386 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2660,
  x2: 2660
});

var _ref387 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2680,
  x2: 2680
});

var _ref388 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2700,
  x2: 2700
});

var _ref389 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2720,
  x2: 2720
});

var _ref390 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2740,
  x2: 2740
});

var _ref391 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2760,
  x2: 2760
});

var _ref392 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2780,
  x2: 2780
});

var _ref393 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2800,
  x2: 2800
});

var _ref394 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2820,
  x2: 2820
});

var _ref395 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2840,
  x2: 2840
});

var _ref396 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2860,
  x2: 2860
});

var _ref397 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2880,
  x2: 2880
});

var _ref398 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2900,
  x2: 2900
});

var _ref399 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2920,
  x2: 2920
});

var _ref400 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2940,
  x2: 2940
});

var _ref401 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2960,
  x2: 2960
});

var _ref402 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 2980,
  x2: 2980
});

var _ref403 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3000,
  x2: 3000
});

var _ref404 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3020,
  x2: 3020
});

var _ref405 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3040,
  x2: 3040
});

var _ref406 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3060,
  x2: 3060
});

var _ref407 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3080,
  x2: 3080
});

var _ref408 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3100,
  x2: 3100
});

var _ref409 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3120,
  x2: 3120
});

var _ref410 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3140,
  x2: 3140
});

var _ref411 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3160,
  x2: 3160
});

var _ref412 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3180,
  x2: 3180
});

var _ref413 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3200,
  x2: 3200
});

var _ref414 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3220,
  x2: 3220
});

var _ref415 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3240,
  x2: 3240
});

var _ref416 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3260,
  x2: 3260
});

var _ref417 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3280,
  x2: 3280
});

var _ref418 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3300,
  x2: 3300
});

var _ref419 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3320,
  x2: 3320
});

var _ref420 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3340,
  x2: 3340
});

var _ref421 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3360,
  x2: 3360
});

var _ref422 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3380,
  x2: 3380
});

var _ref423 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3400,
  x2: 3400
});

var _ref424 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3420,
  x2: 3420
});

var _ref425 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3440,
  x2: 3440
});

var _ref426 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3460,
  x2: 3460
});

var _ref427 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3480,
  x2: 3480
});

var _ref428 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3500,
  x2: 3500
});

var _ref429 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3520,
  x2: 3520
});

var _ref430 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3540,
  x2: 3540
});

var _ref431 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3560,
  x2: 3560
});

var _ref432 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3580,
  x2: 3580
});

var _ref433 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3600,
  x2: 3600
});

var _ref434 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3620,
  x2: 3620
});

var _ref435 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3640,
  x2: 3640
});

var _ref436 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3660,
  x2: 3660
});

var _ref437 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3680,
  x2: 3680
});

var _ref438 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3700,
  x2: 3700
});

var _ref439 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3720,
  x2: 3720
});

var _ref440 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3740,
  x2: 3740
});

var _ref441 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3760,
  x2: 3760
});

var _ref442 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3780,
  x2: 3780
});

var _ref443 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3800,
  x2: 3800
});

var _ref444 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3820,
  x2: 3820
});

var _ref445 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3840,
  x2: 3840
});

var _ref446 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3860,
  x2: 3860
});

var _ref447 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3880,
  x2: 3880
});

var _ref448 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3900,
  x2: 3900
});

var _ref449 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3920,
  x2: 3920
});

var _ref450 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3940,
  x2: 3940
});

var _ref451 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3960,
  x2: 3960
});

var _ref452 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 3980,
  x2: 3980
});

var _ref453 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4000,
  x2: 4000
});

var _ref454 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4020,
  x2: 4020
});

var _ref455 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4040,
  x2: 4040
});

var _ref456 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4060,
  x2: 4060
});

var _ref457 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4080,
  x2: 4080
});

var _ref458 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4100,
  x2: 4100
});

var _ref459 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4120,
  x2: 4120
});

var _ref460 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4140,
  x2: 4140
});

var _ref461 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4160,
  x2: 4160
});

var _ref462 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4180,
  x2: 4180
});

var _ref463 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4200,
  x2: 4200
});

var _ref464 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4220,
  x2: 4220
});

var _ref465 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4240,
  x2: 4240
});

var _ref466 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4260,
  x2: 4260
});

var _ref467 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4280,
  x2: 4280
});

var _ref468 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4300,
  x2: 4300
});

var _ref469 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4320,
  x2: 4320
});

var _ref470 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4340,
  x2: 4340
});

var _ref471 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4360,
  x2: 4360
});

var _ref472 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4380,
  x2: 4380
});

var _ref473 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4400,
  x2: 4400
});

var _ref474 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4420,
  x2: 4420
});

var _ref475 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4440,
  x2: 4440
});

var _ref476 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4460,
  x2: 4460
});

var _ref477 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4480,
  x2: 4480
});

var _ref478 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4500,
  x2: 4500
});

var _ref479 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4520,
  x2: 4520
});

var _ref480 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4540,
  x2: 4540
});

var _ref481 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4560,
  x2: 4560
});

var _ref482 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4580,
  x2: 4580
});

var _ref483 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4600,
  x2: 4600
});

var _ref484 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4620,
  x2: 4620
});

var _ref485 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4640,
  x2: 4640
});

var _ref486 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4660,
  x2: 4660
});

var _ref487 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4680,
  x2: 4680
});

var _ref488 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4700,
  x2: 4700
});

var _ref489 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4720,
  x2: 4720
});

var _ref490 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4740,
  x2: 4740
});

var _ref491 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4760,
  x2: 4760
});

var _ref492 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4780,
  x2: 4780
});

var _ref493 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4800,
  x2: 4800
});

var _ref494 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4820,
  x2: 4820
});

var _ref495 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4840,
  x2: 4840
});

var _ref496 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4860,
  x2: 4860
});

var _ref497 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4880,
  x2: 4880
});

var _ref498 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4900,
  x2: 4900
});

var _ref499 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4920,
  x2: 4920
});

var _ref500 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4940,
  x2: 4940
});

var _ref501 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4960,
  x2: 4960
});

var _ref502 = /*#__PURE__*/React.createElement("line", {
  className: "red-ui-workspace-chart-grid-v",
  y1: 0,
  y2: 5000,
  x1: 4980,
  x2: 4980
});

function SvgLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5000,
    height: 5000,
    pointerEvents: "all",
    style: {
      cursor: "crosshair",
      touchAction: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "red-ui-workspace-chart-event-layer",
    transform: "scale(1)"
  }, _ref2, /*#__PURE__*/React.createElement("g", {
    className: "red-ui-workspace-chart-grid",
    style: {
      visibility: "visible"
    }
  }, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, _ref201, _ref202, _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, _ref209, _ref210, _ref211, _ref212, _ref213, _ref214, _ref215, _ref216, _ref217, _ref218, _ref219, _ref220, _ref221, _ref222, _ref223, _ref224, _ref225, _ref226, _ref227, _ref228, _ref229, _ref230, _ref231, _ref232, _ref233, _ref234, _ref235, _ref236, _ref237, _ref238, _ref239, _ref240, _ref241, _ref242, _ref243, _ref244, _ref245, _ref246, _ref247, _ref248, _ref249, _ref250, _ref251, _ref252, _ref253, _ref254, _ref255, _ref256, _ref257, _ref258, _ref259, _ref260, _ref261, _ref262, _ref263, _ref264, _ref265, _ref266, _ref267, _ref268, _ref269, _ref270, _ref271, _ref272, _ref273, _ref274, _ref275, _ref276, _ref277, _ref278, _ref279, _ref280, _ref281, _ref282, _ref283, _ref284, _ref285, _ref286, _ref287, _ref288, _ref289, _ref290, _ref291, _ref292, _ref293, _ref294, _ref295, _ref296, _ref297, _ref298, _ref299, _ref300, _ref301, _ref302, _ref303, _ref304, _ref305, _ref306, _ref307, _ref308, _ref309, _ref310, _ref311, _ref312, _ref313, _ref314, _ref315, _ref316, _ref317, _ref318, _ref319, _ref320, _ref321, _ref322, _ref323, _ref324, _ref325, _ref326, _ref327, _ref328, _ref329, _ref330, _ref331, _ref332, _ref333, _ref334, _ref335, _ref336, _ref337, _ref338, _ref339, _ref340, _ref341, _ref342, _ref343, _ref344, _ref345, _ref346, _ref347, _ref348, _ref349, _ref350, _ref351, _ref352, _ref353, _ref354, _ref355, _ref356, _ref357, _ref358, _ref359, _ref360, _ref361, _ref362, _ref363, _ref364, _ref365, _ref366, _ref367, _ref368, _ref369, _ref370, _ref371, _ref372, _ref373, _ref374, _ref375, _ref376, _ref377, _ref378, _ref379, _ref380, _ref381, _ref382, _ref383, _ref384, _ref385, _ref386, _ref387, _ref388, _ref389, _ref390, _ref391, _ref392, _ref393, _ref394, _ref395, _ref396, _ref397, _ref398, _ref399, _ref400, _ref401, _ref402, _ref403, _ref404, _ref405, _ref406, _ref407, _ref408, _ref409, _ref410, _ref411, _ref412, _ref413, _ref414, _ref415, _ref416, _ref417, _ref418, _ref419, _ref420, _ref421, _ref422, _ref423, _ref424, _ref425, _ref426, _ref427, _ref428, _ref429, _ref430, _ref431, _ref432, _ref433, _ref434, _ref435, _ref436, _ref437, _ref438, _ref439, _ref440, _ref441, _ref442, _ref443, _ref444, _ref445, _ref446, _ref447, _ref448, _ref449, _ref450, _ref451, _ref452, _ref453, _ref454, _ref455, _ref456, _ref457, _ref458, _ref459, _ref460, _ref461, _ref462, _ref463, _ref464, _ref465, _ref466, _ref467, _ref468, _ref469, _ref470, _ref471, _ref472, _ref473, _ref474, _ref475, _ref476, _ref477, _ref478, _ref479, _ref480, _ref481, _ref482, _ref483, _ref484, _ref485, _ref486, _ref487, _ref488, _ref489, _ref490, _ref491, _ref492, _ref493, _ref494, _ref495, _ref496, _ref497, _ref498, _ref499, _ref500, _ref501, _ref502))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.944dafd1.svg";
export { ForwardRef as ReactComponent };